module.exports = __webpack_public_path__ + "img/142.f4a7665f.jpg";